{
  "name": "reader-demo",
  "version": "0.2.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --aot --output-hashing=all",
    "build:alpha": "ng build --configuration alpha --aot --output-hashing=all",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint",
    "lint:fix": "ng lint --fix"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.8",
    "@angular/cdk": "^21.0.6",
    "@angular/common": "^21.0.8",
    "@angular/compiler": "^21.0.8",
    "@angular/core": "^21.0.8",
    "@angular/forms": "^21.0.8",
    "@angular/material": "^21.0.6",
    "@angular/platform-browser": "^21.0.8",
    "@angular/platform-browser-dynamic": "^21.0.8",
    "@angular/router": "^21.0.8",
    "@angular/service-worker": "^21.0.8",
    "@ericblade/quagga2": "^1.8.4",
    "ngx-barcode-scanner": "^14.0.1",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.5",
    "@angular-eslint/builder": "21.1.0",
    "@angular-eslint/eslint-plugin": "21.1.0",
    "@angular-eslint/eslint-plugin-template": "21.1.0",
    "@angular-eslint/schematics": "21.1.0",
    "@angular-eslint/template-parser": "21.1.0",
    "@angular/cli": "^21.0.5",
    "@angular/compiler-cli": "^21.0.8",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^20.11.30",
    "@typescript-eslint/eslint-plugin": "*",
    "@typescript-eslint/parser": "*",
    "autoprefixer": "^10.4.19",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-prettier": "^5.1.3",
    "jasmine-core": "~5.1.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.38",
    "prettier": "^3.2.5",
    "prettier-eslint": "^16.3.0",
    "tailwindcss": "^3.4.3",
    "typescript": "~5.9.3"
  }
}
